import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../_services/api.service';
import { openCopilotSnackbar } from '../../shared/components/copilot-snackbar/open-copilot-snackbar';

export const aiBlueprintGuard: CanActivateFn = async (route) => {
  const apiService = inject(ApiService);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);
  const translate = inject(TranslateService);

  const id = route.paramMap.get('id');
  if (!id) {
    openCopilotSnackbar(snackBar, translate.instant('AI blueprint not found'));
    return router.parseUrl('/ai-blueprints');
  }

  try {
    await apiService.getTemplate(id, 'user');
    return true;
  } catch (error) {
    if (error instanceof HttpErrorResponse && (error.status === 400 || error.status === 404)) {
      openCopilotSnackbar(snackBar, translate.instant('AI blueprint not found'));
      return router.parseUrl('/ai-blueprints');
    }
    return true;
  }
};
